import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './header.css';

function Header() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('room_')) {
        localStorage.removeItem(key);
      }
    });
    navigate('/login');
  };

  const handleClickOutside = (e) => {
    if (!e.target.closest('.dropdown')) {
      setShowDropdown(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <i className="fas fa-gift me-2"></i>
          GiveLive
        </Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to="./">
                <i className="fas fa-home"></i>
                Trang chủ
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/demo">
                <i className="fas fa-play me-1"></i>
                Demo
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/donate">
                <i className="fas fa-donate me-1"></i>
                Donate
              </Link>
            </li>
            {token && (
              <li className="nav-item">
                <Link className="nav-link" to="/my-rooms">
                  <i className="fas fa-list-alt me-1"></i>
                  Phòng của tôi
                </Link>
              </li>
            )}
          </ul>

          <div className="nav-buttons">
            {token ? (
              <>
                <Link to="/create-room" className="btn btn-create-room">
                  <i className="fas fa-plus-circle me-2"></i>
                  Tạo Give Away
                </Link>
                <div className="dropdown">
                  <button 
                    className="btn btn-settings"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowDropdown(!showDropdown);
                    }}
                  >
                    <i className="fas fa-cog me-1"></i>
                    Cài đặt
                  </button>
                  <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
                    <Link to="/profile" className="dropdown-item">
                      <i className="fas fa-user"></i>
                      Thông tin tài khoản
                    </Link>
                    <button 
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      <i className="fas fa-sign-out-alt"></i>
                      Đăng xuất
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-login">
                  <i className="fas fa-sign-in-alt me-1"></i>
                  Đăng nhập
                </Link>
                <Link to="/register" className="btn btn-register">
                  <i className="fas fa-user-plus me-1"></i>
                  Đăng ký
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header; 